export { default as ApplicationRecord } from './ApplicationRecord';
export { default as User } from './auth/User';
export { default as Session } from './auth/Session';
export { default as PasswordReset } from './auth/PasswordReset';
export { default as PasswordResetConfirmation } from './auth/PasswordResetConfirmation';
export { default as Group } from './auth/Group';
export { default as Terms } from './auth/Terms';
export { default as TermsAcceptance } from './auth/TermsAcceptance';
export { default as EmailVerification } from './auth/EmailVerification';
export { default as EmailVerificationResend } from './auth/EmailVerificationResend';
export { default as StaffVerificationResend } from './auth/StaffVerificationResend';
export { default as VerificationOverride } from './auth/VerificationOverride';

export { default as Auction } from './Auction';
export { default as Lot } from './Lot';
export { default as Bid } from './Bid';
export { default as Wish } from './Wish';

export { default as Media } from './Media';
export { default as Rendition } from './Rendition';

export { default as ContactForm } from './ContactForm';

export { default as Wordpress } from './Wordpress';

export interface ApiError {
  detail: string;
  status: string;
  // Absent on a middleware refusal: nothing is wrong with the payload, so a
  // pointer into the document would be a lie.
  source?: { pointer: string };
  code?: string;
}

/**
 * Whether a failed request was refused by the bid gate.
 *
 * Key off the `code` and nothing else. The status differs by layer - the bid
 * serializer answers 400 and the middleware 403 - and the wording is copy that
 * will change. An ordinary 400 on a bid ("auction closed", "second winner")
 * still deserves the normal inline error, so the code is the only thing that
 * separates "you cannot bid yet" from "that bid was wrong".
 */
export function isVerificationRequired(err: unknown): boolean {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const response = (err as any) && (err as any).response;
  const errors: ApiError[] = (response && response.errors) || [];
  return errors.some(error => error.code === 'verification_required');
}

export {
  setVerificationReminder,
  verificationReminderActive,
} from './verificationReminder';
